document.addEventListener('DOMContentLoaded', function () {
    jQuery(document).bind('gform_confirmation_loaded', function (event, formId) {
        window.dataLayer.push({
            'event': 'gravity_form_submission',
            'gf_form_id': formId
        });
    });
});
